export const colorsTheme = {
  white: '#FFFFFF',
  black: '#000000',
  danger: '#F2383A',

  'gradient-deg': '271deg',
  'gradient-primary': '#044330',
  'gradient-secondary': '#000',

  'primary-color': '#044330',
  'secondary-color': '#12613C',
  'auxiliary-color': '#B6E3D6',

  'bg-color': '#FFFFFF',
  'bg-secondary-color': '#FFFFFF',
  'bg-auxiliary-color': '#343A40',

  'bg-circle-color': '#FFFFFF',
  'bg-circle-hover': '#20C997',
  'bg-circle-text-color': '#000',
  'bg-circle-text-color-hover': '#FFFFFF',

  'filter-button-background': '#044330',
  'filter-button-color': '#FFFFFF',
  'filter-button-border': '#044330',
  'entry-message-color': '#044330',

  'bg-modal-color': '#343A40',

  'dark-color': '#3F3F3F',

  'text-primary': '#FFFFFF',
  'text-secondary': '#FFFFFF',
  'text-tertiary': '#FFFFFF',
  'text-gray': '#4F4F4F',

  'input-color': '#FFFFFF',
  'bg-input-color': '#FFFFFF',
  'info-color': '#6c757d',
  'disabled-color': '#6c757d',
  'card-color': '#495057',
  'modal-border-color': '#ADB5BD',
  'border-color': '#FFFFFF',
  'bg-login-color': '#9f1b1a',
  'bg-login-page-color': '#9f1b1a',

  'login-background': 'https://internet-banking-assets.s3.amazonaws.com/manchaverde/login-background.png',
  'login-background-complement': '#044330',

  'echeck-label-color': '#000',
  'echeck-border-color': '#D2D2D2',
  'echeck-text-color': '#000',
  'echeck-bar-color1': '#044330',
  'echeck-bar-color2': '#044330'
}
